import { restClient } from '@/Core/Services/RestClientService'
import type { InviteUserPayload } from '../Contracts/InvitationPayload'

/**
 * POST /services/users/invitation — invite a new staff member.
 *
 * Backend rejects with 422 + `violations` array when validation fails;
 * callers should surface field-level errors via formContext.setError().
 */
export const InviteUserTask = async (payload: InviteUserPayload): Promise<any> => {
    return restClient.post('/services/users/invitation', { json: payload })
}
